import { FormattedMessage, useIntl } from "react-intl";

import { BodyCopy } from "~/hec/components/ui/body-copy";
import { Card, CardContent } from "~/hec/components/ui/card";
import { handleDocumentNavClick } from "~/hec/components/ui/document-nav-guard";
import { Heading } from "~/hec/components/ui/heading";

import messages from "./messages";

/**
 * Port of hec-composable `goal-banner/levelInstructionsCard.jsx`. The static
 * "Your Lessons" card that leads the level-cards row, linking to the loyalty
 * perks page.
 *
 * SFCC-11723 — HSA-specific copy is message-keyed. The body's embedded
 * "Perk Points" link is rendered via a `<perkLink>` chunk so the anchor stays in
 * code while the surrounding text is translatable.
 */
const LevelInstructionsCard = () => {
  const intl = useIntl();
  return (
    <Card
      className="max-w-[30.75rem] flex-1 rounded-md bg-white/90 p-8"
      data-testid="goal-banner-instructions-card"
    >
      <CardContent className="flex h-full flex-col">
        <div className="px-3 py-4 text-left">
          <Heading
            tag="h2"
            variant="h6"
            className="mb-1"
            data-testid="goal-banner-instructions-heading"
          >
            {intl.formatMessage(messages.yourLessonsHeading)}
          </Heading>
          <BodyCopy data-testid="goal-banner-instructions-copy">
            <FormattedMessage
              {...messages.yourLessonsBody}
              values={{
                perkLink: chunks => (
                  // `/loyalty-perks` is SFRA-proxied: a React-rendered raw
                  // anchor into a full-document navigation, so it carries the
                  // COM-67 re-entrant click guard itself.
                  <a
                    href="/loyalty-perks"
                    className="text-accent underline"
                    onClick={handleDocumentNavClick}
                  >
                    {chunks}
                  </a>
                ),
              }}
            />
          </BodyCopy>
        </div>
      </CardContent>
    </Card>
  );
};

export default LevelInstructionsCard;
